"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserInputErrorForPath = exports.getGraphQLErrorForPath = void 0;
var getGraphQLErrorForPath = function (error, path) {
    var _a;
    if (((_a = error === null || error === void 0 ? void 0 : error.graphQLErrors) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        var err = error.graphQLErrors.find(function (e) {
            var _a;
            if (path !== undefined && ((_a = e === null || e === void 0 ? void 0 : e.path) === null || _a === void 0 ? void 0 : _a[0]) === path) {
                return true;
            }
            return false;
        });
        if (err) {
            return err;
        }
    }
    return undefined;
};
exports.getGraphQLErrorForPath = getGraphQLErrorForPath;
var getUserInputErrorForPath = function (error, path) {
    var graphQLError = exports.getGraphQLErrorForPath(error, path);
    if (graphQLError) {
        var extensions = graphQLError.extensions;
        if ((extensions === null || extensions === void 0 ? void 0 : extensions.code) === 'BAD_USER_INPUT') {
            extensions.faxNumber = extensions.fax;
            return extensions;
        }
    }
    return undefined;
};
exports.getUserInputErrorForPath = getUserInputErrorForPath;
//# sourceMappingURL=ApolloErrorUtil.js.map